<template>
  <div id="ForgotPasswordV2">
    <div class="title">Reset Password</div>
    <b-form>
      <b-form-group
          id="input-group-1"
          label="Enter your email address to reset password"
          label-for="inputEmail"
      >
        <b-form-input
            type="email"
            id="inputEmail"
            v-model="email"
            placeholder="Email address..."
        ></b-form-input>
        <b-form-invalid-feedback id="user-name-error">
          {{ getText.notLoggedIn.login.usernameWarning }}
        </b-form-invalid-feedback>
      </b-form-group>
      <div v-if="showMsg" class="showMsg" :class="{success: success}">{{msg}}</div>
      <b-button
          type="button"
          @click="sendReset"
          class="py-3 reset-password-button"
          variant="cta"
          :disabled="!validEmail"
      >
        <span></span>
        <span>Send Password Reset</span>
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </b-button>
    </b-form>
    <div class="d-flex justify-content-center align-items-center back-text-link">
      <a @click="$emit('signIn')">Back to login</a>
    </div>
  </div>

</template>

<script>

import { mapGetters } from "vuex"
import config from "@/config/constants";
import axios from "axios";

export default {
  name: "ForgotPasswordV2",
  data() {
    return {
      email: null,
      showMsg: false,
      msg: null,
      success: false
    }
  },
  methods: {
    async sendReset() {
      const payload = {
        email: this.email,
        return_domain: config.return_domain,
        lang: this.$store.state.lang
      };

      let res = await axios.post(
          config.api_env + "/application/api-hc/send-reset",
          payload,
          config.options
      );
      if(res.data.success){
        this.success = true;
        this.msg = res.data.message;
        this.showMsg = true;
      }else{
        this.success = true;
        this.msg = this.componentText.errorMessage
        this.showMsg = true;
      }
      setTimeout(()=> {this.showMsg = false}, 10000)
    }
  },
  computed: {
    ...mapGetters(["hardcoded", "skin"]),
    validEmail() {
      return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(this.email);
    },
    componentText(){
      return this.getText.notLoggedIn.forgotPassword
    },
    getLogo() {
      if (this.hardcoded && this.hardcoded.logo) {
        return this.hardcoded.logo;
      } else return this.$store.getters.client.client_logo;
    },
  },
};
</script>
<style lang="less">
#ForgotPasswordV2 {
  width: 100%;
  height: 100%;
  padding: 40px 100px;
  .showMsg {
    text-align: center;
    font-size: 1.4rem;
    color: #ED3A75;
    &.success {
      color: #03B57C;
    }
  }
  .logoContainer {
    height: 100px;
    width: 100%;
    img {
      float: right;
      width: 40%;
      margin-right: 10px;
    }
  }
  .title {
    font-family: "Raptor V3 Black";
    font-size: 3.6rem;
    text-align: center;
    margin-bottom: 60px;
  }
  .reset-password-button {
    width: 100%;
    max-width: 280px;
    border-radius: 10px;
    padding: 12px !important;
    font-family: "Raptor V3 Black";
    font-size: 1.6rem;
    background: #122130 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: auto !important;
    min-width: 280px;
    margin: 44px auto 0;
    letter-spacing: normal;
      .fa-arrow-right {
        background-color: #fff;
        color: #000000;
        border-radius: 5px;
        padding: 10px;
      }
    &.disabled {
      background: grey !important;
    }
  }
  label {
    font-size: 1.5rem;
    color: #000;
    padding-left: 10px;
  }
  input, .form-control {
    height: auto;
    color: #000;
    border: 2px #000 solid;
    padding: 16px;
    border-radius: 5px;
    font-size: 16px;
    line-height: 15px;
    &.invalid {
      border: 2px darkred solid;
    }
  }
  .back-text-link a {
    font-size: 1.6rem;
    color: #000 !important;
    text-decoration: underline;
    text-align: center;
    margin-top: 20px;

    &:hover {
      color: #000 !important;
      text-decoration: none;
    }
  }
}
</style>
